"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInterval = void 0;
var TimeInterval = /** @class */ (function () {
    function TimeInterval(_a) {
        var _b = _a.minutes, minutes = _b === void 0 ? 0 : _b, _c = _a.seconds, seconds = _c === void 0 ? 0 : _c, _d = _a.milliseconds, milliseconds = _d === void 0 ? 0 : _d;
        this.minutes = Math.abs(minutes);
        this.seconds = Math.abs(seconds);
        this.milliseconds = Math.abs(milliseconds);
    }
    TimeInterval.prototype.inMilliseconds = function () {
        return (this.milliseconds +
            (this.seconds + this.minutes * TimeInterval.SECONDS_IN_MINUTE) * TimeInterval.MILLISECONDS_IN_SECOND);
    };
    TimeInterval.SECONDS_IN_MINUTE = 60;
    TimeInterval.MILLISECONDS_IN_SECOND = 1000;
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
